import moment from 'moment-timezone';
import {invitationsInDb} from './data/invitation';

function inviteOrganisations(_organisationSourceId, invitations) {
  invitationsInDb.push({
    ...invitations,
    creationDate: moment().format('YYYY-MM-DDTHH:mm:ss')
  });
  return new Promise(resolve => {
    setTimeout(() => resolve(), 0);
  });
}

function cancelPendingInvitation(invitationId) {
  return new Promise((resolve, reject) => {
    const index = invitationsInDb.findIndex(el => el.id === invitationId);
    if (index === -1) { reject(); }
    const deleted = invitationsInDb.splice(index, 1);
    if (deleted.length !== 1) { reject(); }
    resolve();
  });
}

function resendInvitation(invitationId, reason) {
  return new Promise((resolve, reject) => {
    const index = invitationsInDb.findIndex(el => el.id === invitationId);
    if (index === -1) { reject(); }
    invitationsInDb[index] = {
      ...invitationsInDb[index],
      resendReason: reason,
      lastSentDate: moment().format('YYYY-MM-DDTHH:mm:ss')
    };
    resolve();
  });
}

function pendingInvitationExists(invitationId) {
  return Promise.resolve(
    invitationsInDb.some(invitation => invitation.id === invitationId)
  );
}

function getByProjectId(projectId) {
  return Promise.resolve(
    invitationsInDb.some(invitation => invitation.project.projectId === projectId)
  );
}

function searchBy() {
  return Promise.resolve([]);
}

export default {
  inviteOrganisations,
  cancelPendingInvitation,
  resendInvitation,
  pendingInvitationExists,
  getByProjectId,
  searchBy
};
